var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentyNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0216 33.3621H2.97836C1.33609 33.3621 0 32.026 0 30.3837V9.61711C0 7.97477 1.33609 6.63867 2.97836 6.63867H37.0216C38.6638 6.63867 39.9999 7.97477 39.9999 9.61703V30.3837C40 32.026 38.6639 33.3621 37.0216 33.3621Z",
    fill: "#ECF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0216 6.63867H20V33.3621H37.0216C38.6639 33.3621 40 32.026 40 30.3838V9.61711C40 7.97477 38.6639 6.63867 37.0216 6.63867Z",
    fill: "#EBECEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0637 16.3402H33.702C34.4069 16.3402 34.9785 15.7687 34.9785 15.0637C34.9785 14.3587 34.4069 13.7871 33.702 13.7871H19.0637C18.3587 13.7871 17.7871 14.3587 17.7871 15.0637C17.7871 15.7687 18.3587 16.3402 19.0637 16.3402Z",
    fill: "#CACED3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.702 18.8086H19.0637C18.3587 18.8086 17.7871 19.3802 17.7871 20.0852C17.7871 20.7902 18.3587 21.3617 19.0637 21.3617H33.702C34.4069 21.3617 34.9785 20.7902 34.9785 20.0852C34.9786 19.3802 34.4069 18.8086 33.702 18.8086Z",
    fill: "#CACED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3828 23.6592H19.0637C18.3587 23.6592 17.7871 24.2307 17.7871 24.9357C17.7871 25.6407 18.3587 26.2123 19.0637 26.2123H26.3828C27.0878 26.2123 27.6594 25.6407 27.6594 24.9357C27.6595 24.2307 27.0878 23.6592 26.3828 23.6592Z",
    fill: "#CACED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8513 27.83H6.29805C5.59305 27.83 5.02148 27.2584 5.02148 26.5534V23.2768C5.02148 20.7662 7.06406 18.7236 9.57469 18.7236C12.0853 18.7236 14.1279 20.7662 14.1279 23.2768V26.5534C14.1278 27.2584 13.5562 27.83 12.8513 27.83Z",
    fill: "#CACED3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57469 21.2763C7.06406 21.2763 5.02148 19.2338 5.02148 16.7231C5.02148 14.2125 7.06406 12.1699 9.57469 12.1699C12.0853 12.1699 14.1279 14.2125 14.1279 16.7231C14.1279 19.2338 12.0853 21.2763 9.57469 21.2763Z",
    fill: "#CACED3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7021 13.7871H20V16.3403H33.7021C34.4071 16.3403 34.9787 15.7687 34.9787 15.0637C34.9787 14.3587 34.4071 13.7871 33.7021 13.7871Z",
    fill: "#CACED3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7021 18.8086H20V21.3618H33.7021C34.4071 21.3618 34.9787 20.7902 34.9787 20.0852C34.9787 19.3802 34.4071 18.8086 33.7021 18.8086Z",
    fill: "#CACED3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.383 23.6592H20V26.2124H26.383C27.088 26.2124 27.6595 25.6408 27.6595 24.9358C27.6596 24.2307 27.088 23.6592 26.383 23.6592Z",
    fill: "#CACED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentyNumber);
export default __webpack_public_path__ + "static/media/IdentyNumber.75279763b3fee8a860b84a6596349e89.svg";
export { ForwardRef as ReactComponent };